import { plainToInstance } from 'class-transformer'
import i18n from 'vue-i18n'

import { MenuSectionNames, SocketNames } from '../../../../../components'
import { BaseNodeModelData } from '../../../BaseNode/BaseNodeDataModel'
import { BaseNodeModel } from '../../../BaseNode/BaseNodeModel'
import { CustomNode, CustomNodeComponent, NodeTypes } from '../../../index'
import SampleSendInvoiceNode from '../ui/SampleSendInvoiceNode.vue'
import SendInvoiceSidebar from '../ui/SendInvoiceNodeSidebar.vue'
import { SendInvoiceNodeProps } from './types'

export default class SendInvoiceNodeBuilder extends CustomNodeComponent {
  menuSection = MenuSectionNames.Communications
  sidebarComponent = SendInvoiceSidebar

  constructor(i18n: i18n, nodeProps: SendInvoiceNodeProps) {
    super(SampleSendInvoiceNode, SendInvoiceNode, NodeTypes.SendInvoice, i18n, nodeProps)
  }

  getBaseNodeModel = ([ x, y ]: [number, number]) => {
    return {
      data: plainToInstance(SendInvoiceNodeData, {
        type: NodeTypes.SendInvoice,
        product_id: null,
        cash_register_id: null,
        success_output: CustomNode.LastSocketId += 1,
        discount: null,
        count: {
          type: 'Constant',
          value: 1
        },
        inactive_action: { output: CustomNode.LastSocketId += 1, time: 0 },
      }),
      output: CustomNode.LastSocketId += 1,
      input: CustomNode.LastSocketId += 1,
      color: null,
      x,
      y,
    }
  }
}

export class SendInvoiceNode extends CustomNode {
  data: SendInvoiceNodeData
  declare nodeProps: SendInvoiceNodeProps

  constructor(name: NodeTypes.SendInvoice, model: BaseNodeModel, nodeProps: SendInvoiceNodeProps) {
    super(name, model, nodeProps)

    if (model.data instanceof SendInvoiceNodeData) {
      this.socketActions.createOutput(model.data.inactive_action.output, SocketNames.Inactive)
      this.socketActions.createOutput(model.data.success_output, SocketNames.Success)

      this.data = model.data

      if (this.data.count && this.data.count.type === "Constant") {
        this.data.count.value = +this.data.count.value
      }
    } else {
      throw new Error('To node come unknown data')
    }
  }

  setInactiveTime(time: number): void {
    this.data.inactive_action.time = time
  }

  setInactiveRemove(state: boolean): void {
    this.data.inactive_remove = state
  }

  switchDiscount(): void {
    if (this.data.discount) {
      this.data.discount = null
    } else {
      this.data.discount = {
        type: 'Calculate',
        value: ''
      }
    }
  }

  setProduct(productId: number): void {
    this.data.product_id = productId
  }

  setCashRegister(cashRegisterId: number): void {
    this.data.cash_register_id = cashRegisterId
  }

  setCountModel(countType: SendInvoiceNodeData['count']['type']) {
    if (countType === "Constant") {
      this.data.count = {
        type: 'Constant',
        value: 1
      }
    }

    if (countType === "Calculate") {
      this.data.count = {
        type: 'Calculate',
        value: ''
      }
    }
  }
}

export class SendInvoiceNodeData extends BaseNodeModelData {
  declare type: NodeTypes.SendInvoice
  product_id!: number | null
  cash_register_id!: number | null

  success_output!: number

  // todo переделать потом. не ок в таком виде по общей концепции каста на классы через трансформер. пока
  discount!: { type: 'Calculate', value: string } | null
  count!: { type: 'Constant', value: string | number } |  { type: 'Calculate', value: string }
  inactive_action!: { output: number, time: number }

  inactive_remove!: boolean
}
